import http, { API_BASE, handler } from './http-service';

interface LogQuery {
  year: string | number;
  month: string | number;
  day?: string | number;
  timeZone?: string;
  interval?: string | number;
}

const baseURL = `${API_BASE}/logs`;

export const findBySensorId = async (sensorId: string, query?: LogQuery, showMonth?: boolean) => {
  let url = `${baseURL}/${sensorId}`;
  if (query) {
    if (showMonth === true) {
      query.day = '';
    }
    url += `?year=${query.year}&month=${query.month}`;
    if (query.day) url += `&day=${query.day}`;
    if (query.interval) url += `&interval=${query.interval}`;
    if (query.timeZone) url += `&timezone=${query.timeZone}`;
  }
  return handler(() => http.get(url));
}

const logService = { findBySensorId };

export default logService;
